import React, { useEffect, useState } from 'react';
import { Button } from '@mui/material';
import HttpClient from '../../../utils/HttpClient';
// import toast from 'react-hot-toast';
import './form.css'
import ReactSelect from 'react-select';
import ServiceAddBox from './ServiceAddBox';
const MAX_SELECTIONS = 5;

function SecondForm({ onNext, onBack, formTwoData, setFormTwoData, initProduct, initDoc, CompanyID }) {
    const [Servicename, setServicename] = useState([])
    const [imageFile, setimageFile] = useState("");
    const [showAddNewService, setShowAddNewService] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        onNext();
    };

    const handleChange = (e) => {
        const { name, value } = e.target
        setFormTwoData(prev => ({ ...prev, [name]: value }));
    }

    // input mapping
    const handleProductChange = (e, i) => {
        const { name, value } = e.target
        const newData = formTwoData.productData?.map((ele, ind) => {
            if (i === ind) {
                return { ...ele, [name]: value }
            } else {
                return ele
            }
        });
        // console.log("formTwoDataChange", name, value, i, formTwoData, newData);
        setFormTwoData(prev => ({ ...prev, productData: newData }))
    }

    //handleDocumentName
    const handleDocumentName = (e, i) => {
        const { name, value } = e.target;
        setFormTwoData(prev => {
            const newData = [...prev.doc];
            newData[i] = { ...newData[i], [name]: value };
            return { ...prev, doc: newData };
        });
    }

    // handle Image
    const handleImage = async (e, i) => {
        let formData = new FormData()
        formData.append("image", e.target.files[0])
        const res = await HttpClient.fileUplode("image-upload", "POST", formData);
        if (res && res?.status) {
            // handleProductChange({ name: "image" })
            handleProductChange({ target: { name: "image", value: res?.data?.url } }, i)

        }
    }
    //Document
    const handleDocument = async (e, i) => {
        let formData = new FormData()
        formData.append("image", e.target.files[0])
        const res = await HttpClient.fileUplode("image-upload", "POST", formData);
        if (res && res.status) {
            setFormTwoData((prevData) => {
                const newDocData = [...prevData.doc];
                newDocData[i] = { ...newDocData[i], pdf: res.data.url }; // Update the specific document data in the array
                return { ...prevData, doc: newDocData }; // Return the updated state
            });
        }
    }

    const serviceNameData = async () => {
        try {
            const res = await HttpClient.requestData("companyType-wise-service/" + CompanyID, "GET", {})
            if (res && res?.status) {
                setServicename(res?.data);
            }
        }
        catch (error) {
            console.error("Error fetching data:", error);
        }
    }

    useEffect(() => {
        serviceNameData()
    }, [])

    const handleServiceAddSuccess = () => {
        setShowAddNewService(false);
        serviceNameData();
    }

    const selectedServices = formTwoData.serviceID.map(id => {
        const service = Servicename.find(service => service._id === id);
        return { value: id, label: service?.name };
    });

    // Helper function to get all available options in the required format
    const serviceOptions = Servicename.map(item => ({ value: item._id, label: item.name }));

    const handleServiceChange = (selectedOptions) => {
        if (selectedOptions && selectedOptions.length > MAX_SELECTIONS) {
            return;
        }
        const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
        const selectedNames = selectedOptions ? selectedOptions.map(option => option.label) : [];

        setFormTwoData(prev => ({
            ...prev,
            serviceID: selectedValues,
            serviceName: selectedNames,
        }));
    };

    return (
        <form >
            <div className="row">
                <div className="col-md-12 mt-3 ">
                    <label htmlFor="formGroupExampleInput">About Company<span className="text-danger">&nbsp;*</span></label>
                    <textarea
                        rows="3" cols="10"
                        className="form-control"
                        placeholder="Short description (maximum 100 words)" Enter
                        name="companyDescription"
                        value={formTwoData.companyDescription}
                        onChange={handleChange}
                    // onChange={(e) => { setFormTwoData({ ...formTwoData, companyDescription: e.target.value }) }}
                    />
                </div>

                <div className="col-md-12 mt-3 ">
                    <label htmlFor="formGroupExampleInput">Services<span className="text-danger">&nbsp;*</span></label>
                    {/* <ReactSelect
                        isMulti
                        options={Servicename.map(item => ({ value: item._id, label: item.name }))}
                        value={formTwoData.serviceID.map(id => {
                            const service = Servicename.find(service => service._id === id);
                            return { value: id, label: service?.name };
                        })}
                        onChange={(selectedOptions) => {
                            const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
                            const selectedNames = selectedOptions ? selectedOptions.map(option => option.label) : [];
                            setFormTwoData(prev => ({
                                ...prev,
                                serviceID: selectedValues,
                                serviceName: selectedNames,
                            }));
                        }}
                        isOptionDisabled={(option) => {
                            const selectedCount = (formTwoData.serviceID || []).length;
                            const isSelected = (formTwoData.serviceID || []).includes(option.value);
                            return selectedCount >= 5 && !isSelected;
                        }}
                    /> */}

                    <ReactSelect
                        isMulti
                        options={serviceOptions}
                        value={selectedServices}
                        onChange={handleServiceChange}
                        placeholder="Select up to 5 services..."
                        isOptionDisabled={(option) => {
                            const selectedCount = (formTwoData.serviceID || []).length;
                            const isSelected = (formTwoData.serviceID || []).includes(option.value);
                            return selectedCount >= MAX_SELECTIONS && !isSelected;
                        }}
                    />

                    {!showAddNewService && (
                        <div className='d-flex mt-1 justify-content-end '>
                            <button
                                onClick={() => setShowAddNewService(true)}
                                className='btn bg-warning mt-2'
                            >
                                Add More
                            </button>
                        </div>
                    )}

                    {showAddNewService && (
                        <ServiceAddBox CompanyTypeID={CompanyID} onSuccess={handleServiceAddSuccess} />
                    )}
                </div>

                <div className="col-md-12 mt-3 ">
                    <label htmlFor="formGroupExampleInput">Product Description<span className="text-danger">&nbsp;*</span></label>
                    {formTwoData?.productData?.map((item, i) => {
                        return (
                            <div key={i} className=' border border-1 mb-2 mx-3 rounded '>
                                <div className='d-flex mt-2 mx-2'>
                                    <label className='col-3 mt-1'>Product Name :<span className="text-danger"></span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter Product Name"
                                        name="name"
                                        value={item?.name}
                                        onChange={(e) => handleProductChange(e, i)}
                                    />
                                </div>
                                <div className='d-flex mt-1 mx-2'>
                                    <label className='col-3 mt-1'>Product Description :<span className="text-danger"></span></label>
                                    <textarea
                                        rows="3"
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter Product Description"
                                        name="description"
                                        value={item?.description}
                                        onChange={(e) => handleProductChange(e, i)}

                                    />
                                </div>
                                <div className='d-flex mt-1 mx-2'>
                                    <label className='col-3 mt-1'>Product Image <span className=' text-danger '>(560x300px)</span>:<span className="text-danger"></span></label>

                                    <input
                                        type="file"
                                        className="mt-1"
                                        name="image"
                                        onChange={(e) => handleImage(e, i)}
                                    />
                                    <img src={item?.image} alt="" id='preview' height="70px" width="70px" className='mb-2' />
                                </div>

                                {<div className='d-flex mt-1 justify-content-end '>

                                    <button
                                        type='button'
                                        className='btn bg-danger text-white mb-2 mx-2'
                                        onClick={() => {
                                            const newData = formTwoData.productData?.filter((ele, ind) => i !== ind)
                                            setFormTwoData(prev => ({ ...prev, productData: newData }))
                                        }}
                                    >
                                        Delete
                                    </button>
                                </div>}
                            </div>)
                    })}
                    <div className='d-flex mt-1 justify-content-end '>

                        <button
                            className='btn bg-warning mt-2'
                            onClick={(e) => {
                                e.preventDefault()
                                const newData = [...formTwoData.productData, initProduct]
                                setFormTwoData(prev => ({ ...prev, productData: newData }))
                            }}
                            disabled={formTwoData.productData.length >= 5}
                        >
                            Add More
                        </button>
                    </div>
                </div>

                <div className="col-md-12 mt-3 ">
                    <label htmlFor="formGroupExampleInput">Product Files<span className="text-danger">&nbsp;*</span></label>
                    {formTwoData?.doc?.map((item, i) => {
                        return (
                            <div key={i} className=' border  mb-2 mx-3 rounded '>

                                <div className='d-flex mt-1 mx-2 mb-2'>
                                    <label className='col-3 mt-1'>Document Name :<span className="text-danger"></span></label>
                                    {/* <p className='border border-1 bg-secondary text-white rounded px-1 py-1' style={{ position: "relative", marginRight: "90px", cursor: "pointer", marginTop: "4px" }}>Chose a file</p> */}
                                    <input
                                        type="text"
                                        className="mt-1 form-control"
                                        name="docName"
                                        value={item.docName}
                                        onChange={(e) => handleDocumentName(e, i)}
                                    />
                                </div>
                                <div className='d-flex mt-1 mx-2 mb-2'>

                                    <label className='col-3 mt-1'>Document File :<span className="text-danger"></span></label>
                                    {/* <p className='border border-1 bg-secondary text-white rounded px-1 py-1' style={{ position: "relative", marginRight: "90px", cursor: "pointer", marginTop: "4px" }}>Chose a file</p> */}
                                    <input
                                        key={i}
                                        type="file"
                                        className="mt-1 "
                                        // className="mt-1 hideNoChoosen"
                                        name="pdf"

                                        onChange={(e) => handleDocument(e, i)}
                                    />
                                    {item?.pdf && (
                                        <div className='mt-2'>
                                            <a href={item?.pdf} target="_blank" rel="noopener noreferrer" download="" className=' text-primary mt-2'>
                                                Open PDF <i className="fa-solid fa-download"></i>
                                            </a>
                                            {/* <p>{item?.pdf}</p> */}
                                        </div>
                                    )}
                                    {!item?.pdf && (
                                        <p className='mt-2'></p>
                                    )}

                                    {/* <img src={item?.image} alt="" id='preview' height="70px" width="70px" className='mb-2' /> */}
                                </div>
                                {<div className='d-flex mt-1 justify-content-end '>

                                    <button
                                        type='button'
                                        className='btn bg-danger text-white mb-2 mx-2'
                                        onClick={() => {
                                            const newData = formTwoData.doc?.filter((ele, ind) => i !== ind)
                                            setFormTwoData(prev => ({ ...prev, doc: newData }))
                                        }}
                                    >
                                        Delete
                                    </button>
                                </div>}
                            </div>)
                    })}
                    <div className='d-flex mt-1 justify-content-end '>

                        <button
                            className='btn bg-warning mt-2'
                            onClick={(e) => {
                                e.preventDefault();
                                const newData = [...formTwoData.doc, { ...initDoc }]; // Initialize new document data as empty
                                setFormTwoData(prev => ({ ...prev, doc: newData }));
                            }}
                        >
                            Add More Document
                        </button>
                    </div>

                </div>
                <div className="col-md-12 mt-3 ">
                    <label >Video URL: <span className="text-danger">&nbsp;*</span></label>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Video URL"
                        name="videoUrl"
                        value={formTwoData?.videoUrl}
                        onChange={handleChange}
                    />
                    {/* onChange={(e) => { setFormTwoData({ ...formTwoData, companyDescription: e.target.value }) }} */}

                </div>

            </div>







            {/* Your form fields for the second step */}
            <Button onClick={onBack} variant="contained" className='mx-2 mt-2'>
                Back
            </Button>
            <Button onClick={handleSubmit} variant="contained" color="primary" className='mx-2 mt-2'>
                Next
            </Button>
        </form>
    );
}
export default SecondForm;